import React from "react";
import Head from "next/head";
import { connect } from "react-redux";
import { wrapper } from "@/store";
import {
  getStaticProps as getStaticPropsMethod,
  getStaticPaths as getStaticPathsMethod,
} from "@gc-npm/astro/astro-pages-handler";

import AstroLayout from "@gc-npm/components.astro.astro-layout";
import Footer from "@gc-npm/components.footer";
import MetaData from "@gc-npm/core.meta-data";
import Header from "@gc-npm/components.header-isr";

import FullConfig from "@/containers/full-config";
import { myConfigProps } from "./configurador";

class Public extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      breadcrumbsProps,
      headerProps,
      seoInfo,
      footerProps,
      orionInfo,
      orionAlias,
      version = "",
      infoSeated,
      loggedStatus
    } = this.props;

    const isMiMovistar = version === "mimovistar";
    if (isMiMovistar && orionInfo && orionInfo["components-order"]) {
      orionInfo["components-order"] = orionInfo["components-order"].filter(
        (cmp) =>
          cmp !== "cms-module-product-info-1" &&
          cmp !== "cms-component-product-thumbs-1"
      );
    }

    return (
      <>
        {isMiMovistar && (
          <Head>
            <style>{`
/* =============================
   Ocultación Mi Movistar específica
   ============================= */
/* OCULTAMOS la segunda tab del header de solo tv */
ul.pill-section > li:nth-of-type(2) {
  display: none !important;
}

/* 🔹 OCULTAR solo elementos del bloque cms-ml-detail-card-list-1 */
section[id="cms-component-filter-card-list-1.cms-ml-detail-card-list-1"],
section#cms-component-filter-card-list-1\\.cms-ml-detail-card-list-1,
section#cms-component-filter-card-list-1.cms-ml-detail-card-list-1,
div[id="cms-component-filter-card-list-1.cms-ml-detail-card-list-1"],
#cms-component-filter-card-list-1\\.cms-ml-detail-card-list-1.container.collapsed-cards,
#cms-component-filter-card-list-1.cms-ml-detail-card-list-1.container.collapsed-cards {
  display: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 🔹 OCULTAR el div colapsado específico del bloque cms-ml-detail-card-list-4 */
div[id="cms-component-filter-card-list-1.cms-ml-detail-card-list-4"].container.collapsed-cards,
#cms-component-filter-card-list-1\\.cms-ml-detail-card-list-4.container.collapsed-cards,
#cms-component-filter-card-list-1.cms-ml-detail-card-list-4.container.collapsed-cards {
  display: none !important;
}

/* 🔹 OCULTAR títulos y filas (solo para el bloque -1) */
#cms-component-filter-card-list-1 h2.text.container.filter-cards--title,
#cms-component-filter-card-list-1 .container.filter-cards--row,
.cms-component-filter-card-list-1.cms-ml-detail-card-list-1 h2.text.container.filter-cards--title,
.cms-component-filter-card-list-1.cms-ml-detail-card-list-1 .container.filter-cards--row {
  display: none !important;
}

/* 🔹 OCULTAR también el DIV con clase filter-cards--title que muestra "Ofertas de TV..." */
div.text.container.filter-cards--title.text-kind--div {
  display: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* 🔹 Limpieza visual: eliminar posibles huecos residuales */
[id="cms-component-filter-card-list-1.cms-ml-detail-card-list-1"] {
  margin: 0 !important;
  padding: 0 !important;
}
`}</style>
          </Head>
        )}
        <MetaData seoInfo={seoInfo} />
        <Header {...breadcrumbsProps} {...headerProps} loggedStatus={loggedStatus} />
        <main className={infoSeated && isMiMovistar ? "mimovistar" : ""}>
          {isMiMovistar && (
            <div style={{ paddingTop: "1rem" }}>
              <FullConfig />
            </div>
          )}
          <div className="finalSticky" />
          <AstroLayout
            seoInfo={seoInfo}
            breadcrumbsProps={breadcrumbsProps}
            headerProps={headerProps}
            orionInfo={{ ...orionInfo }}
            orionAlias={orionAlias}
            footerProps={footerProps}
          />
        </main>
        <Footer footerProps={footerProps} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  context: state.main.context,
  infoSeated: state.main.userPq,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Public);

const ASTRO_ROUTE_BASE_PATH = "/tv";
export const getStaticPaths = async () =>
  getStaticPathsMethod({
    routeBasePath: ASTRO_ROUTE_BASE_PATH,
    repoId: process.platform === "win32" ? "" : undefined,
    fallback: "blocking",
    includeVersionContextVariants: false,
    includeLoggedVariants: true,
  });

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  let configProps = {};
  const isNotProd = `${process.env.NEXT_PUBLIC_ENV_NAME}` !== "prod";

  const info = await getStaticPropsMethod(data, {
    routeBasePath: ASTRO_ROUTE_BASE_PATH,
  });

  if (info?.props?.version === "mimovistar") {
    configProps = await myConfigProps(data);
  }

  const allProps2Return = {
    ...configProps,
    props: info.props,
    revalidate: info.revalidate || 300,
  };
  if (isNotProd && allProps2Return.revalidate) {
    delete allProps2Return.revalidate;
  }
  return allProps2Return;
});
